import { render, staticRenderFns } from "./TableRowNewPatientsTotal.vue?vue&type=template&id=0dd232d8&lang=pug&"
import script from "./TableRowNewPatientsTotal.vue?vue&type=script&lang=js&"
export * from "./TableRowNewPatientsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd232d8')) {
      api.createRecord('0dd232d8', component.options)
    } else {
      api.reload('0dd232d8', component.options)
    }
    module.hot.accept("./TableRowNewPatientsTotal.vue?vue&type=template&id=0dd232d8&lang=pug&", function () {
      api.rerender('0dd232d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowNewPatientsTotal.vue"
export default component.exports